import { ESelfServeTaskStatus, TaskCategories } from 'common/contracts';
import { ISetupChecklistCategory } from 'pages/Layout/SetupChecklist/types';

import { Observable } from './observable';

class SetupChecklistStateService {
  // TODO: move to false before merge
  readonly isExpanded = new Observable<boolean>(false);
  readonly isVerifyBusinessModalOpen = new Observable<boolean>(false);
  readonly isSendAgreementModalOpen = new Observable<boolean>(false);
  readonly categories = new Observable<ISetupChecklistCategory[]>([]);
  readonly selectedCategory = new Observable<
    (typeof TaskCategories)[keyof typeof TaskCategories] | ''
  >('');

  clear = () => {
    this.isExpanded.set(false);
    this.isVerifyBusinessModalOpen.set(false);
    this.isSendAgreementModalOpen.set(false);
    this.categories.set([]);
    this.selectedCategory.set('');
  };

  setIsExpanded = (expanded: boolean) => this.isExpanded.set(expanded);
  setIsVerifyBusinessModalOpen = (open: boolean) =>
    this.isVerifyBusinessModalOpen.set(open);
  setIsSendAgreementModalOpen = (open: boolean) =>
    this.isSendAgreementModalOpen.set(open);
  setCategories = (cat: ISetupChecklistCategory[]) => this.categories.set(cat);
  setSelectedCategory = (
    cat: (typeof TaskCategories)[keyof typeof TaskCategories] | ''
  ) => this.selectedCategory.set(cat);

  toggleChecklistExpandedState = (
    fetchTasks: () => void,
    forceState?: boolean
  ) => {
    const newState =
      forceState !== undefined ? forceState : !this.isExpanded.get();
    setupChecklistStateService.setIsExpanded(newState);

    fetchTasks();

    if (newState) {
      this.resetSelectedCategory();
    }
  };

  resetSelectedCategory = () => {
    const selectedCategoryTitle = this.categories
      .get()
      ?.find(({ tasks }) =>
        tasks.find(({ status }) => status === ESelfServeTaskStatus.OPEN)
      )?.title;

    this.setSelectedCategory(selectedCategoryTitle || '');
  };
}

export const setupChecklistStateService = new SetupChecklistStateService();
